import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import { colors, spacing, caption, subtitle2, borderRadius } from 'ui/theme';
import { mediumShadow } from 'ui/theme/shadows';

export const SingleDatePickerWrapper = styled.div`
  width: ${pxToRem(379)};
  /** Fixed height to ensure buttons are in same location when cycling through, account for 6 rows of dates */
  height: ${pxToRem(518)};
  border-radius: ${spacing.half};
  ${mediumShadow};
  gap: ${spacing.base};
  background-color: ${colors.white};
`;

export const InputBar = styled.div`
  background: ${colors.backgroundInteractiveStrong};
  display: flex;
  padding: ${spacing.base};
  border-radius: ${`${spacing.half} ${spacing.half} 0 0`};
`;

export const TimeZonePickerWrapper = styled.div`
  padding-left: ${spacing.half};
  display: flex;
  align-items: center;
`;

export const RelativeDateMenu = styled.div`
  ${caption}
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${spacing.double};
  padding: ${spacing.base};
  color: ${colors.textSecondary};
  line-height: ${spacing.plusHalf};
  > :nth-child(3) {
    grid-column: 1 / span 2; /* Third child spans both columns */
  }
`;

export const RelativeDateSet = styled.div`
  display: flex;
  gap: ${spacing.base};
`;

export const RelativeDateColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.base};
`;

export const RelativeDateFragment = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${spacing.half};
`;

export const RelativeDateExample = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${spacing.half};
`;

export const RelativeDateValue = styled.span`
  background: ${colors.backgroundTertiary};
  color: ${colors.textPrimary};
  text-align: center;
  width: ${spacing.double};
  height: ${spacing.plusHalf};
  border-radius: ${borderRadius.md};
`;

export const SingleDateFooterWrapper = styled.div`
  ${subtitle2}
  display: flex;
  justify-content: space-between;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: ${spacing.base};
  align-items: center;
  background-color: ${colors.grey1};
  color: ${colors.textPrimary};
  border-bottom-right-radius: ${spacing.half};
  border-bottom-left-radius: ${spacing.half};
`;

export const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.half};
`;

export const ErrorText = styled.div`
  ${caption}
  color: ${colors.red100};
  padding: ${spacing.base};
  padding-bottom: 0;
  display: flex;
  gap: ${spacing.half};
  align-items: center;
`;
